import { useEffect, useState } from "react";
import SimpleDialog from "@rio-cloud/rio-uikit/SimpleDialog";
import { Scheduling } from "../../../../../../../models/schedule";
import { useNavigate } from "react-router-dom";
import { ServiceBayScheduleDialog } from "../../../../../../../components/kanban/components/form/components/serviceBaySchedule/dialogs/serviceBayScheduleDialog";
import { ServiceBay, ServiceBaySchedule } from "../../../../../../../models/serviceBay";
import { fetchServiceBayList, fetchServiceBayScheduleList } from "../../../../../../../api/fetchServiceBay";
import { IServiceBayScheduleForm } from "../../../../../../../components/kanban/components/form/components/serviceBaySchedule/dialogs/serviceBayScheduleDialog";
import { createServiceBaySchedule, deleteServiceBaySchedule } from "../../../../../../../api/serviceBay";
import VehicleIcon from "../../../../../../../components/VehicleIcon";
import moment from "moment";

import ErrorDialog from "../../../../../../../components/dialogs/ErrorDialog";
import SuccessDialog from "../../../../../../../components/dialogs/SuccessDialog";

import "../styles.css";
import { getAssetRioPlan } from "../../../../../../../services/assetService";
import { useMediaQuery } from "@mui/material";

interface ISchedulingDetailDialogProps {
  show: boolean;
  onClose: () => void;
  scheduling: Scheduling | undefined;
}

const SchedulingDetailDialog = ({
  show,
  onClose,
  scheduling,
}: ISchedulingDetailDialogProps) => {
  const navigate = useNavigate();

  const [scheduleServiceBays, setScheduleServiceBays] = useState<ServiceBaySchedule[]>([]);
  const [serviceBays, setServiceBays] = useState<ServiceBay[]>([]);
  const [serviceBayScheduleDialogOpen, setServiceBayScheduleDialogOpen] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<{ title: string, body: string } | null>(null);
  const [successMessage, setSuccessMessage] = useState<{ title: string, body: string } | null>(null);

  const [newBox, setNewBox] = useState<ServiceBaySchedule | undefined>(undefined);

  const { plans } = getAssetRioPlan(scheduling?.asset?.id ?? '');
  const isResponsiveView = useMediaQuery("(max-width: 767px)");

  useEffect(() => {
    const fetchData = async () => {
      const serviceBays = await fetchServiceBayList();
      setServiceBays(serviceBays ?? []);

      // Get first and last day of the month
      const localCurrentDate = new Date();
      const firstDayOfMonth = new Date(
        localCurrentDate.getFullYear(),
        localCurrentDate.getMonth(),
        1
      );
      const lastDayOfYear = new Date(
        localCurrentDate.getFullYear(),
        11,
        0
      );

      const scheduleServiceBays = await fetchServiceBayScheduleList(firstDayOfMonth, lastDayOfYear, serviceBays?.map((serviceBay) => serviceBay.id ?? "") ?? []);
      setScheduleServiceBays(scheduleServiceBays ?? []);
    };

    fetchData();
  }, []);

  const dialogContent = (
    <div className="padding-25">
      <div className="text-size-20 text-bold padding-bottom-25 text-color-gray">
        {scheduling?.scheduleNumber}
      </div>

      <div className="text-size-20 text-bold padding-bottom-25">
        {scheduling?.asset?.group}
      </div>

      <div className={`${isResponsiveView ? "flex-col gap-3" : "row"}`}>
        {[
          { label: "Motorista", value: scheduling?.driver?.name, width: "col-4" },
          { label: "CNH", value: scheduling?.driver?.license, width: "col-2" },
          { label: "Telefone", value: scheduling?.driver?.phone, width: "col-3" },
          { label: "E-mail", value: scheduling?.driver?.email, width: "col-3" },
        ].map((field, index) => (
          <div key={index} className={`${isResponsiveView ? "w-full mb-6" : field.width}`}>
            <label className="block text-sm text-size-20 text-color-black font-bold mb-2">
              {field.label}
            </label>
            <div className="mt-1 p-2 border schedule-data__info">
              <div className="truncate">{field.value}</div>
            </div>
          </div>
        ))}
      </div>

                    <div className="padding-20 bg-lighter margin-y-20 vehicle-detais">
                        <div className="flex items-start gap-4">
                            <VehicleIcon 
                                chassis={scheduling?.asset?.chassis} 
                                size={80}
                            />

                            <div className="flex-1 padding-left-10">
            <p className="text-color-black text-size-16 font-medium m-0">
              {scheduling?.asset?.name} | Placa:{" "}
              {scheduling?.asset?.licensePlate}
            </p>
            <p className="text-color-status-resting text-size-14 m-0">
              Chassi - {scheduling?.asset?.chassis}
              <br />
              Odômetro: {scheduling?.asset?.odometer} km | Horímetro:{" "}
              {scheduling?.asset?.hourmeter} h
            </p>
          </div>

          <div className="flex gap-6 margin-bottom-20">
            {scheduling?.asset?.tags?.map((tag, index) => (
              <span key={index} className="px-2 py-1 green-tag">
                {tag}
              </span>
            ))}
            {/* <span className="px-2 py-1 green-tag">RIO</span>
                        <span className="px-2 py-1 green-tag">Em Garantia</span>
                        <span className="px-2 py-1 bg-white white-tag">Volkstotal Prev</span> */}
          </div>
        </div>

        <div className="padding-10">
          <div className="car-workshop">
            <ul className="flex flex-column gap-15 m-0">
              <li className="flex justify-between">
                <div className="text-color-black">Campanhas de campo</div>
                <div className="text-bold">{scheduling?.asset?.id ? plans : 'Grátis'}</div>
              </li>

              <li className="flex justify-between">
                <div className="text-color-black">
                  {scheduling?.checkup?.description}
                </div>
                <div className="text-bold">{scheduling?.asset?.id ? plans : 'Grátis'}</div>
              </li>

              {/* <li className="flex justify-between">
                                <div className="text-color-black">
                                    Total em peças
                                </div>
                                <div className="text-color-black">R$4.200,00</div>
                            </li> */}

              <li className="flex justify-between">
                <div className="text-color-black">Total em serviços</div>
                <div className="text-color-black">{scheduling?.totalPrice}</div>
              </li>
              <li className="flex justify-between border-top-only border-width-1">
                <div className="text-color-black text-bold">Total</div>
                <div className="text-color-black text-bold">
                  {scheduling?.totalPrice}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div>
        <div className="text-size-14 text-medium">Importante!</div>
        <div className="text-size-14">{scheduling?.observation}</div>
      </div>

      <div className="revision-itens margin-y-20">
        <h5 className="text-size-20 text-bold margin-bottom-10">
          Itens cobertos na revisão
        </h5>
        <div className="p-4 bg-white border">
          <div className="space-y-5 text-size-14 text-color-black m-0 padding-left-10">
            {scheduling?.checkup?.services.length === 0 && <p>-</p>}
            {scheduling?.checkup?.services.map((item, index) => (
              <div key={index} className="padding-bottom-10">
                <p className="text-bold">{item.name}</p>
                {item.items.map((subItem, subIndex) => (
                  <p key={subIndex} className="padding-left-20">
                    {subItem}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="revision-itens">
        <h5 className="text-size-20 text-bold margin-bottom-0">
          Descrição dos Serviços Contratados
        </h5>
        <div className="text-size-14 margin-bottom-10">
          Espaço para descrever informações importantes sobre “Serviços
          Contratados”, adicionados no agendamento.
        </div>
        <div className="p-4 bg-white border">
          {scheduling?.otherServices?.map((item, index) => (
            <div key={index}>
              <p>{item}</p>
            </div>
          ))}
          {(scheduling?.otherServices ?? []).length === 0 && <p>-</p>}
        </div>
      </div>

      <div className="revision-itens observation">
        <h5 className="text-size-20 text-bold margin-bottom-0">Observações</h5>
        <div className="text-size-14 margin-bottom-10">
          Espaço para relatar problemas na manutenção do seu veículo.
        </div>
        <div className="p-4 bg-white border">
          <ul className="space-y-5 text-size-14 text-color-black m-0 padding-left-10">
            <li className="flex justify-between">
              <span>{scheduling?.observation || "-"}</span>
            </li>
          </ul>
        </div>
      </div>

      <div
        className={`revision-itens flex ${isResponsiveView ? "flex-col gap-4" : "justify-between gap-6"
          } mt-4`}
      >
        {[
          {
            title: "Concessionária",
            content: (
              <>

                <p className="m-0">{scheduling?.dealership?.address}</p>
              </>
            ),
          },
          {
            title: "Data e horário",
            content: (
              <>
                <p className="m-0 text-size-h5">
                  {scheduling?.date.toLocaleDateString("pt-BR", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}
                </p>
                <p className="m-0">
                  {scheduling?.date.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>
              </>
            ),
          },
          {
            title: "Consultor",
            content: <p className="m-0 text-size-h5">{scheduling?.consultant}</p>,
          },
          {
            title: "Box",
            content: <p className="m-0 text-size-h5">{scheduling?.serviceBaySchedule?.serviceBay?.name ?? newBox?.serviceBay?.name}</p>,
          }
        ].map((item, idx) => (
          <div
            key={idx}
            className={`${isResponsiveView ? "w-full mb-10" : "w-1/3"}`}
          >
            <h5 className="text-size-20 text-color-black font-bold mb-2">
              {item.title}
            </h5>
            <div className="p-4 bg-white border card">{item.content}</div>
          </div>
        ))}
      </div>

      {/* <div className="warning-row">
        <h5 className="text-color-status-resting">Atenção!</h5>
        <p className="text-color-warning text-size-18 font-semibold">
          Os itens de cobertura do seu plano de contrato de manutenção estão
          sujeitas a análise técnica de garantia, podendo a garantia ser
          indeferida por violação e ou mau uso.
        </p>
        <p className="padding-top-20">
          <Checkbox indeterminate checked>
            Estou ciente sobre as regras da garantia
          </Checkbox>
        </p>
      </div> */}
    </div>
  );

  const dialogFooter = (
    <div className="display-flex justify-content-center gap-20">
      <button
        type="button"
        className="btn btn-primary width-250"
        onClick={onClose}
      >
        Fechar
      </button>

      <button
        type="button"
        className="btn btn-secondary width-250"
        onClick={() =>
          navigate(
            `/dealership/${scheduling?.maintenanceStatus === 'FINISHED' ? 'history' : 'maintenance-monitoring'}?chassi=${scheduling?.asset?.chassis}`
          )
        }
      >
        Acompanhar manutenção
      </button>

      {!scheduling?.serviceBaySchedule && scheduling?.maintenanceStatus !== 'FINISHED' && !newBox && scheduling?.occurrenceId && (
        <button
          type="button"
          className="btn btn-default width-250"
          onClick={() => setServiceBayScheduleDialogOpen(true)}
        >
          Agendar box
        </button>
      )}
    </div>
  );

  return (
    <>
      <SimpleDialog
        show={show}
        title="Detalhes do agendamento"
        subtitle="Confira abaixo as informações do agendamento"
        content={dialogContent}
        footer={dialogFooter}
        bsSize="lg"
        onClose={onClose}
        useOverflow
      />

      <ServiceBayScheduleDialog
        isOpen={serviceBayScheduleDialogOpen}
        onClose={() => setServiceBayScheduleDialogOpen(false)}
        onDelete={async () => {
          if (scheduling?.serviceBaySchedule?.id) {
            await deleteServiceBaySchedule(scheduling.serviceBaySchedule.id);
          }
        }}
        scheduleServiceBays={scheduleServiceBays}
        serviceBays={serviceBays}
        occurrence={{
          id: scheduling?.occurrenceId ?? "",
          vehicleChassis: scheduling?.asset?.chassis ?? "",
          vehicleLicensePlate: scheduling?.asset?.licensePlate ?? "",
          criticality: scheduling?.criticality ?? 0,
          scheduleNumber: scheduling?.scheduleNumber ?? "",
          serviceBaySchedule: scheduling?.serviceBaySchedule ?? undefined,
        }}
        setServiceBaySchedule={async (data?: IServiceBayScheduleForm) => {
          if (data) {
            const startTime = data.startTime;
            const endTime = data.endTime;

            const newBox = {
              startDate: startTime,
              endDate: endTime,
              serviceBay: data.serviceBay ? serviceBays.find(serviceBay => serviceBay.id === data.serviceBay) : undefined,
              occurrence: scheduling?.occurrenceId ?? undefined,
            }

            const result = await createServiceBaySchedule({
              startDate: newBox.startDate?.toISOString(),
              endDate: newBox.endDate?.toISOString(),
              serviceBay: newBox.serviceBay?.id,
              occurrence: newBox.occurrence,
            });

            if (result.error) {
              setErrorDialogOpen(true);
              setErrorMessage({
                title: "Erro ao agendar box",
                body: result.error
              });
            } else {
              setSuccessDialogOpen(true);
              setSuccessMessage({
                title: "Box agendado com sucesso",
                body: "O box foi agendado com sucesso."
              });
              setNewBox({
                startDate: newBox.startDate,
                endDate: newBox.endDate,
                serviceBay: newBox.serviceBay,
                occurrence: scheduling?.occurrenceId ? {
                  id: scheduling?.occurrenceId,
                  vehicleChassis: scheduling?.asset?.chassis ?? "",
                  vehicleLicensePlate: scheduling?.asset?.licensePlate ?? "",
                  criticality: scheduling?.criticality ?? 0,
                  scheduleNumber: scheduling?.scheduleNumber ?? "",
                } : undefined,
              });
              setServiceBayScheduleDialogOpen(false);
            }
          }
        }}
      />

      <ErrorDialog
        show={errorDialogOpen}
        onClose={() => setErrorDialogOpen(false)}
        body={errorMessage?.body}
        title={errorMessage?.title ?? "Erro"}
      />

      <SuccessDialog
        show={successDialogOpen}
        onClose={() => setSuccessDialogOpen(false)}
        body={successMessage?.body}
        title={successMessage?.title ?? "Sucesso"}
      />
    </>
  );
};

export default SchedulingDetailDialog;
